import React, {useEffect, useState} from 'react';
import styleCom from "./REGCOM.module.scss";
import DataGrid from "../../components/DataGrid/DataGrid";
import DatePicker from "components/DatePicker/DatePicker";
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import Button from "components/Button/Button";
import RadioGroup from "../../components/Radio/RadioGroup";


const RenderHtml = (props) => {


    const [editClinicalObj, setEditClinicalObj] = useState(props.dsClinialData);
    const [rows_subjectList, setRows_subjectList] = useState(editClinicalObj);
    const cols_subjectList = [
         { key: 'oindex',      name: '순번',    width: '20%' }
        ,{ key: 'visitDate',   name: '방문일자', width: '30%'}
        ,{ key: 'w24VisitYn',  name: '24주',    width: '25%'}
        ,{ key: 'w48VisitYn',  name: '48주',    width: '25%'}
    ];

    const radioOptions = [
        {mapCd: "lowSes", value: "0", label: "건강보험"}  //자격여부
        ,{mapCd: "lowSes", value: "1", label: "차상위/급여1,2종"}
        ,{mapCd: "presetYn", value: "0", label: "No"}
        ,{mapCd: "presetYn", value: "1", label: "Yes"}
    ];

    function getOptionList(cdValue) {
        return radioOptions.filter(option => option.mapCd === cdValue);
    }

    const [clinicalIdx, setClinicalIdx] = useState('');




    /* Tool ****************************************************************************** */
    const getEditValue = (oindex, field) => {
        return editClinicalObj?.[oindex]?.[field];
    };
    const setEditValue = (oindex, field, value) => {

        setEditClinicalObj(prev => {
            const updated = [...prev];
            updated[oindex] = { ...updated[oindex], [field]: value };
            return updated;
        })
        setRows_subjectList(editClinicalObj);

    };



    /* Event ****************************************************************************** */



    //그리드 데이터 클릭
    const handleClick_DtlGrid_row = (e) => {
        setClinicalIdx(e.row.oindex-1);
    }

    // pk 가 문자열 숫자라고 가정
    const getNextId = () => {
        // 숫자로 변환해서 max 찾기
        const maxId = editClinicalObj.reduce((max, item) => {
            const numId = Number(item.oindex);
            return numId > max ? numId : max;
        }, 0);

        return String(maxId + 1); // 다음 id는 문자형 숫자 + 1
    };

    const buttonClick_addRow = () => {
        const newId = getNextId();
        const newRow =
            {
                 mstId: props.workId  ,hsptCd: props.workHsptCd
                ,oindex:newId ,regYmd:"" ,regHh:"",regMm:""
                ,csys:""   ,cdia:""     ,cpr:""
            };


        setEditClinicalObj(prev => {
            const newData = [...prev, newRow];
            setRows_subjectList(newData);  // 바로 최신 데이터로 세팅
            return newData;
        });

    };

    const getMaxtId = () => {
        // 숫자로 변환해서 max 찾기
        const maxId = editClinicalObj.reduce((max, item) => {
            const numId = Number(item.oindex);
            return numId > max ? numId : max;
        }, 0);

        return String(maxId); // 다음 id는 문자형 숫자 + 1
    };

    const buttonClick_deleteRow = () => {
        setEditClinicalObj(prev => prev.filter(item => item.oindex !== getMaxtId()));

    };



    useEffect(() => {
        setRows_subjectList(editClinicalObj);
        props.setDsClinialData(editClinicalObj);

    }, [editClinicalObj]);

    /* ****************************************************************************** Event */

    let clinicalDataHtml=<></>;

    clinicalDataHtml =
        <>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <div style={{display:"flex", gap:"20px"}}>
                    <Button variant="Primary" size="md" addStyle={{width: "100px", height: "35px"}}
                            onClick={() => buttonClick_addRow()}>
                        + 추가등록
                    </Button>
                    <Button variant="Secondary" size="md" addStyle={{width: "100px", height: "35px"}}
                            onClick={() => buttonClick_deleteRow()}>
                        - 삭제
                    </Button>
                </div>

                <DataGrid
                    cols={cols_subjectList}
                    rows={rows_subjectList}
                    rowHeight={37}
                    onCellClick={(e) => handleClick_DtlGrid_row(e)}
                    sortable={true}
                    isNodataView={true}
                />
            </div>
            <div className={styleCom.title_wrap}>
                <h3>Clinical Data</h3>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={2} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>순번</div>
                    <div>
                        <InputUnitText type={"text"} width={"70px"} readOnly={true}
                                       value={getEditValue(clinicalIdx, "oindex")}/>
                    </div>
                    <div>방문일자</div>
                    <div>
                        <DatePicker dateFormat={'yyyy-MM-dd'} isDisabled={false}
                                    selDate={ymdToDate(getEditValue(clinicalIdx, "visitDate"))}
                                    onChange={(date) => setEditValue(clinicalIdx, "visitDate", dateToYMD(date))}
                        />
                    </div>
                    <div>24주 방문</div>
                    <RadioGroup options={getOptionList('presetYn')}
                                selectedValue={getEditValue(clinicalIdx, "w24VisitYn")}
                                onChange={(value) => setEditValue(clinicalIdx, 'w24VisitYn', value)}/>
                    <div>48주 방문</div>
                    <RadioGroup options={getOptionList('presetYn')}
                                selectedValue={getEditValue(clinicalIdx, "w24VisitYn")}
                                onChange={(value) => setEditValue(clinicalIdx, 'w24VisitYn', value)}/>
                </Table>
            </div>
            <div className={styleCom.main_wrap} style={{marginTop: "10px", padding: "20px"}}>
                <Table variant='default' rowCnt={24} colSize={['25%', '75%', '25%', '75%']} rowSize={'56px'}>
                    <div>첫번째 진료실 - 수축기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={getEditValue(clinicalIdx, 'osys1')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'osys1', value)}/>
                    </div>
                    <div>첫번째 진료실 - 이완기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={getEditValue(clinicalIdx, 'odia1')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'odia1', value)}/>
                    </div>
                    <div>첫번째 진료실 - 맥박수</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} value={getEditValue(clinicalIdx, 'opr1')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'opr1', value)}/>
                    </div>
                    <div>두번째 진료실 - 수축기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={getEditValue(clinicalIdx, 'osys2')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'osys2', value)}/>
                    </div>
                    <div>두번째 진료실 - 이완기 혈압</div>
                    <div style={{height: "56px"}}>
                        <InputUnitText type={"number"} unit={"mmHg"} value={getEditValue(clinicalIdx, 'odia2')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'odia2', value)}/>
                    </div>
                    <div>두번째 진료실 - 맥박수</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} value={getEditValue(clinicalIdx, 'opr2')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'opr2', value)}/>
                    </div>
                    <div>이전 방문과 비교시 약변경 발생 여부</div>
                    <div className={'col_merge'}>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'medChangeYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'medChangeYn', val)}/>
                    </div>
                    <div>이전 방문과 비교시 혈압약 증가(증량)</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'medUp')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'medUp', val)}/>
                    </div>
                    <div>이전 방문과 비교시 혈압약 감소(감량)</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'medDown')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'medDown', val)}/>
                    </div>

                    <div>ACEi 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'aceiYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'aceiYn', val)}/>
                    </div>
                    <div>ACEi 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'aceiName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'aceiName', value)}/>
                    </div>
                    <div>ACEi 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"}
                                       value={getEditValue(clinicalIdx, 'aceiDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'aceiDose', value)}/>
                    </div>
                    <div>ARB 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'arbYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'arbYn', val)}/>
                    </div>
                    <div>ARB 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'arbName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'arbName', value)}/>
                    </div>
                    <div>ARB 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"}
                                       value={getEditValue(clinicalIdx, 'arbDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'arbDose', value)}/>
                    </div>
                    <div>Entresto 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'entrestoYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'entrestoYn', val)}/>
                    </div>
                    <div>Entresto 용량</div>
                    <div>
                        <InputUnitText type={"number"} unit={"mg"} value={getEditValue(clinicalIdx, 'entrestoDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'entrestoDose', value)}/>
                    </div>
                    <div>베타차단제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'bbYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'bbYn', val)}/>
                    </div>
                    <div>베타차단제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'bbName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'bbName', value)}/>
                    </div>
                    <div>베타차단제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={getEditValue(clinicalIdx, 'bbDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'bbDose', value)}/>
                    </div>
                    <div>칼슘통로차단제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'ccbYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'ccbYn', val)}/>
                    </div>
                    <div>칼슘통로차단제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'ccbName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'ccbName', value)}/>
                    </div>
                    <div>칼슘통로차단제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={getEditValue(clinicalIdx, 'ccbDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'ccbDose', value)}/>
                    </div>
                    <div>이뇨제 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'diureticsYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'diureticsYn', val)}/>
                    </div>
                    <div>이뇨제 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'diureticsName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'diureticsName', value)}/>
                    </div>
                    <div>이뇨제 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={getEditValue(clinicalIdx, 'diureticsDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'diureticsDose', value)}/>
                    </div>
                    <div>SGLT2 처방 여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'sglt2iYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'sglt2iYn', val)}/>
                    </div>
                    <div>SGLT2 성분명</div>
                    <div>
                        <InputUnitText type={"String"} value={getEditValue(clinicalIdx, 'sglt2iName')} maxLength={50}
                                       onChange={(value) => setEditValue(clinicalIdx, 'sglt2iName', value)}/>
                    </div>
                    <div>SGLT2 용량</div>
                    <div className={"col_merge"}>
                        <InputUnitText type={"number"} unit={"mg"} value={getEditValue(clinicalIdx, 'sglt2iDose')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'sglt2iDose', value)}/>
                    </div>
                    <div>스타틴 혹은 에제티미브 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'llaYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'llaYn', val)}/>
                    </div>
                    <div>경구 혈당 강하제 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'ohaYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'ohaYn', val)}/>
                    </div>
                    <div>인슐린 처방여부</div>
                    <div className={"col_merge"}>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'insulinYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'insulinYn', val)}/>
                    </div>
                    <div>부작용 발생여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'aeYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'aeYn', val)}/>
                    </div>
                    <div>어지럼증 발생여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'aeDizzinessYn')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'aeDizzinessYn', val)}/>
                    </div>
                    <div>두통 발생여부</div>
                    <div>
                        <RadioGroup options={getOptionList('presetYn')}
                                    selectedValue={getEditValue(clinicalIdx, 'aeHeadache')}
                                    onChange={(val) => setEditValue(clinicalIdx, 'aeHeadache', val)}/>
                    </div>
                    <div>부작용 상세설명</div>
                    <div>
                        <InputUnitText type={"number"} maxLength={200} value={getEditValue(clinicalIdx, 'aeText')}
                                       onChange={(value) => setEditValue(clinicalIdx, 'aeText', value)}/>
                    </div>


                </Table>
            </div>


        </>
    ;


    let renderHtml =
        <></>
    ;

    if (props.contentId === "T2") {
        renderHtml = clinicalDataHtml;

    } else {

    }
    return (
        <>
            {renderHtml}
        </>
    );

};

export default RenderHtml;

